// Actions for the product configuration NGXS state.
import { PpmFormlyLayout, PpmProductResponse, ProductDataInstanceInput } from '../../pages/products/product.model';

export namespace Products {
  export class StartConfiguration {
    static readonly type = '[Products] Start Configuration';
    constructor(
      public readonly projectId: string,
      public readonly productId: string,
      public readonly instanceInput: ProductDataInstanceInput,
      public readonly formlyLayout: PpmFormlyLayout,
      public readonly productState: string
    ) {}
  }

  export class TriggerCalculation {
    static readonly type = '[Products] Trigger Calculation';
  }

  export class CalculationStatusPolled {
    static readonly type = '[Products] Calculation Status Polled';
    constructor(
      public readonly status: string,
      public readonly instanceOutputs: unknown | null
    ) {}
  }

  export class FieldUpdateReceived {
    static readonly type = '[Products] Field Update Received';
    constructor(public readonly ppmResponse: PpmProductResponse) {}
  }

  export class OutputSelected {
    static readonly type = '[Products] Output Selected';
    constructor(public readonly selectedOutputKey: number) {}
  }
}
